import { useContext } from 'react';
import { useAPI } from '../services/api';
import { useHistory } from 'react-router-dom';
import ToastContext from '../contexts/toast-context';
import SaleForm from '../components/sale/SaleForm';
import { toISODateString } from '@itdeptutahcountygovernment/date-formatting';

const CreatePage = () => {
  const api = useAPI();
  const history = useHistory();
  const { handleError, success } = useContext(ToastContext);
  const initialValues = {
    price: 0.0,
    date: toISODateString(new Date()),
    active: true,
  };

  const save = async (sale) => {
    try {
      await api.post('/sales', { ...sale, customerId: 1, employeeId: 1 });
      success('created new sale!');
      history.push(`/`);
    } catch (e) {
      handleError(e);
    }
  };

  return (
    <div>
      <h1 className="my-2">Create New Sale</h1>
      <SaleForm initialValues={initialValues} save={save} />
    </div>
  );
};

export default CreatePage;
